import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalizeFirstLetter(
  word: string,
  capitalizeAll: boolean = false
): string {
  if (word.split(" ").length > 1 && capitalizeAll) {
    return word
      .split(" ")
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(" ");
  }
  return word[0].toUpperCase() + word.slice(1);
}
